import { useMutation, useQuery } from "@tanstack/react-query";

import {
  createCoupon,
  editCoupon,
  fetchActiveCoupons,
  fetchCouponInfo,
} from "clients/packageManagementClient";
import { fetchBasicPackagesInfo } from "clients/omsClient";
import {
  ACTIVE_COUPONS_DEFAULT_LIMIT,
  ACTIVE_COUPONS_DEFAULT_OFFSET,
} from "constants/coupons";

export { fetchActiveCoupons, fetchCouponInfo } from "clients/packageManagementClient";

export const useCreateCoupon = () => useMutation({ mutationFn: createCoupon });

export const useBasicPackagesInfo = (enabled = true) =>
  useQuery({
    queryKey: ["basicPackagesInfo"],
    queryFn: fetchBasicPackagesInfo,
    enabled,
    staleTime: 5 * 60 * 1000,
  });

export const getActiveCouponsListQueryKey = () => ["activeCoupons", "list"];

export const useActiveCouponsList = (enabled = true) =>
  useQuery({
    queryKey: getActiveCouponsListQueryKey(),
    queryFn: () =>
      fetchActiveCoupons({
        offset: ACTIVE_COUPONS_DEFAULT_OFFSET,
        limit: ACTIVE_COUPONS_DEFAULT_LIMIT,
      }),
    enabled,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

export const getCouponInfoQueryKey = (couponCode) => [
  "couponInfo",
  couponCode?.trim() ?? "",
];

export const useCouponInfo = (couponCode, { enabled = true } = {}) =>
  useQuery({
    queryKey: getCouponInfoQueryKey(couponCode),
    queryFn: () => fetchCouponInfo(couponCode),
    enabled: enabled && Boolean(couponCode?.trim()),
    staleTime: 60 * 1000,
  });

export const useEditCoupon = () => useMutation({ mutationFn: editCoupon });
